/**
 *
 * TableDataNotFound
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import PaginatedTable from 'components/PaginatedTable';
import { formatColumns } from 'components/PaginatedTable/helpers';
function TimelineTable({ headingData, rowData = [] }) {
  const FORMATTED_COLUMN_ID = formatColumns(headingData);

  return (
    <PaginatedTable
      data={rowData}
      tableHeading={FORMATTED_COLUMN_ID}
      isPaginated={false}
    />
  );
}

TimelineTable.propTypes = {
  headingData: PropTypes.array,
  rowData: PropTypes.array,
};

export default memo(TimelineTable);
